export default __webpack_public_path__ + "static/investigacion1-d6038da46614dc9d5c1b9725d5f062e8.png";